'use client'

import clsx from 'clsx'
import { useTranslations } from 'next-intl'

import HeroArenaIcon from '@/assets/icons/tasks-feed/hero-arena.svg'
import HeroBrandDriftIcon from '@/assets/icons/tasks-feed/hero-brand-drift.svg'
import HeroBrandJgglIcon from '@/assets/icons/tasks-feed/hero-brand-jggl.svg'

import S from './TasksHero.module.scss'

const TasksHero = () => {
  const t = useTranslations('tasksPage.hero')

  return (
    <section className={S.root}>
      <div className={S.glow} aria-hidden />
      <div className={S.dots} aria-hidden />
      <div className={S.content}>
        <p className={S.label}>{t('label')}</p>
        <h1 className={S.headline}>
          <span className={S.line}>{t('headline')}</span>
          <span className={clsx(S.line, S.lineBrands)}>
            {t.rich('headlineBrands', {
              arena: chunks => (
                <span className={S.brandWord}>
                  <span className={clsx(S.logo, S.logoArena)} aria-hidden>
                    <HeroArenaIcon className={S.logoArenaIcon} />
                  </span>
                  {chunks}
                </span>
              ),
              brands: () => (
                <span className={S.logoStack} aria-hidden>
                  <span className={clsx(S.logo, S.logoJggl)}>
                    <HeroBrandJgglIcon className={S.logoJgglIcon} />
                  </span>
                  <span className={clsx(S.logo, S.logoDrift)}>
                    <HeroBrandDriftIcon className={S.logoDriftIcon} />
                  </span>
                </span>
              )
            })}
          </span>
        </h1>
      </div>
    </section>
  )
}

export default TasksHero
